import { Injectable, signal } from '@angular/core';

const DEFAULT_TITLE = 'Preparing your download';
const DEFAULT_DESCRIPTION = 'Your download will be ready shortly.';

@Injectable({ providedIn: 'root' })
export class DownloadProgressService {
  readonly #visible = signal(false);
  readonly #title = signal(DEFAULT_TITLE);
  readonly #description = signal(DEFAULT_DESCRIPTION);

  readonly visible = this.#visible.asReadonly();
  readonly title = this.#title.asReadonly();
  readonly description = this.#description.asReadonly();

  show(title?: string, description?: string): void {
    this.#title.set(title ?? DEFAULT_TITLE);
    this.#description.set(description ?? DEFAULT_DESCRIPTION);
    this.#visible.set(true);
  }

  hide(): void {
    this.#visible.set(false);
  }
}
